export const AUTH_LOGIN = "AUTH_LOGIN"